var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveLiveScreen = function SvgActiveLiveScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 29
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 26,
    fill: "currentColor",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 41c-6.073 0-11-4.927-11-11s4.927-11 11-11 11 4.927 11 11-4.927 11-11 11m0-2.74A8.253 8.253 0 0 0 38.26 30 8.247 8.247 0 0 0 30 21.74 8.253 8.253 0 0 0 21.74 30 8.26 8.26 0 0 0 30 38.26m0-4.177a4.103 4.103 0 0 1-4.104-4.093A4.11 4.11 0 0 1 30 25.885a4.103 4.103 0 0 1 4.094 4.105A4.094 4.094 0 0 1 30 34.083"
  })));
};
export default SvgActiveLiveScreen;